var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{on:{"click":_vm.showEmojiPopover}},[_c('IconEmojis',{staticClass:"message-input-tool cursor-pointer icon-small"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }